module.exports = __webpack_public_path__ + "static/model-14a1a581750d2d1303851d87e50b44eb.png";